export const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 60
};